module.exports = __webpack_public_path__ + "d060b7ae57f29f1afbec8e616a488469.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/s/s11.jpg
// module id = 687
// module chunks = 0